// File: frontend/src/data/marketingDemoData.js
//
// ⚠️ FICTIONAL MARKETING DEMONSTRATION DATA ONLY.
// None of the values below are real. They exist purely to populate the public
// landing-page marketing visuals. No production tenant, customer, router,
// balance, phone number, email or transaction reference is represented here.
// These fixtures are static and never fetched from any backend.

export const DEMO_NETWORK = {
  name: "Central Connect Wi-Fi",
  primaryRouter: "Kampala Central Router",
};

export const DEMO_METRICS = {
  monthlyRevenue: 4_850_000,     // UGX
  revenueToday: 286_500,         // UGX
  activeUsers: 64,
  connectedRouters: 12,
  onlineRouters: 11,
  availableVouchers: 248,
  redeemedVouchers: 1_482,
  transactionsToday: 86,
  bandwidthUsedGb: 968.4,
};

// 7-day revenue trend (relative, UGX '000s) for the dashboard chart.
export const DEMO_REVENUE_SERIES = [
  { d: "Mon", v: 312 },
  { d: "Tue", v: 468 },
  { d: "Wed", v: 351 },
  { d: "Thu", v: 542 },
  { d: "Fri", v: 610 },
  { d: "Sat", v: 588 },
  { d: "Sun", v: 690 },
];

// Fictional hotspot locations for the network diagram.
//
// Every location carries the SAME fields the detail card shows, because the
// diagram is selectable: choosing a location has to produce a card about that
// location, not a fixed one. Each of these fields is something PesaFii really
// samples from a router — active users, uptime, CPU, free memory and traffic
// all come from RouterOS on a fixed cadence (backend/jobs/
// routerObservabilitySampler.js), so none of them is an invented capability.
//
// An offline location keeps its last known figures and reports no active users,
// which is what the real card does.
export const DEMO_LOCATIONS = [
  { id: "central-cafe", name: "Central Café", users: 18, online: true, uptime: "12d 4h", cpu: 34, memory: 51, dataUsedGb: 312.6, lastSeen: "just now" },
  { id: "campus-hotspot", name: "Campus Hotspot", users: 27, online: true, uptime: "26d 11h", cpu: 51, memory: 62, dataUsedGb: 604.2, lastSeen: "just now" },
  { id: "market-wifi", name: "Market Wi-Fi", users: 12, online: true, uptime: "5d 19h", cpu: 22, memory: 44, dataUsedGb: 148.9, lastSeen: "just now" },
  { id: "guest-house", name: "Guest House Network", users: 0, online: false, uptime: "—", cpu: 0, memory: 0, dataUsedGb: 61.4, lastSeen: "2h ago" },
  { id: "community-hub", name: "Community Hub", users: 15, online: true, uptime: "9d 2h", cpu: 29, memory: 48, dataUsedGb: 203.7, lastSeen: "just now" },
];

// The location the diagram starts on.
export const DEMO_DEFAULT_LOCATION_ID = "central-cafe";

// Fictional vouchers (codes are obviously demo placeholders).
export const DEMO_VOUCHERS = [
  { code: "PF-DEMO-7H-A41", plan: "7 Hours", price: 1000, status: "available" },
  { code: "PF-DEMO-24H-B82", plan: "24 Hours", price: 2000, status: "redeemed" },
  { code: "PF-DEMO-3D-C17", plan: "3 Days", price: 5000, status: "available" },
];

export const DEMO_VOUCHER_STATS = { available: 248, redeemed: 1482, expired: 37 };

// Fictional recent transactions. References are clearly demo-only.
export const DEMO_TRANSACTIONS = [
  { ref: "DEMO-TXN-001", customer: "Demo Customer 01", amount: 2000, status: "completed" },
  { ref: "DEMO-TXN-002", customer: "Demo Customer 02", amount: 1000, status: "completed" },
  { ref: "DEMO-TXN-003", customer: "Demo Customer 03", amount: 5000, status: "processing" },
];

export const DEMO_WALLET = {
  available: 3_920_000,   // UGX
  collectionsToday: 286_500,
  activity: [40, 62, 48, 71, 66, 83, 92], // relative bars
};

// Analytics fixtures.
export const DEMO_ANALYTICS = {
  activeUsers: 64,
  avgSessionMins: 42,
  dataGb: 968.4,
  peakHours: [8, 14, 22, 40, 55, 72, 90, 78, 60, 44, 30, 18], // 12 two-hour buckets
  popularPackage: "24 Hours · UGX 2,000",
  usageByRouter: [
    { name: "Campus Hotspot", pct: 92 },
    { name: "Central Café", pct: 74 },
    { name: "Market Wi-Fi", pct: 58 },
  ],
};

// Payment-flow amounts (fictional, generic Mobile Money language).
export const DEMO_PAYMENT_AMOUNTS = [1000, 2000, 5000];

// UGX formatter for the visuals.
export const fmtUGX = (n) => `UGX ${Number(n || 0).toLocaleString()}`;
